// Super-admin "Sign in as user" (impersonation) session handling.
// We back up the admin's real token, swap in the impersonation token, and restore on exit.

export function startImpersonation({ context, token, slug, targetName }) {
  if (context === "agency") {
    localStorage.setItem("mc_imp_backup_agency", localStorage.getItem("mc_agency_token") || "");
    localStorage.setItem("mc_agency_token", token);
    localStorage.setItem("mc_imp_context", "agency");
  } else {
    localStorage.setItem("mc_imp_backup_ws", localStorage.getItem("mc_ws_token") || "");
    localStorage.setItem("mc_ws_token", token);
    localStorage.setItem("mc_imp_context", "workspace");
  }
  localStorage.setItem("mc_imp_target", targetName || "user");
  window.location.href = context === "agency" ? "/console" : `/${slug}`;
}

export function stopImpersonation() {
  const ctx = localStorage.getItem("mc_imp_context");
  if (ctx === "agency") {
    const b = localStorage.getItem("mc_imp_backup_agency");
    if (b) localStorage.setItem("mc_agency_token", b);
    else localStorage.removeItem("mc_agency_token");
  } else if (ctx === "workspace") {
    const b = localStorage.getItem("mc_imp_backup_ws");
    if (b) localStorage.setItem("mc_ws_token", b);
    else localStorage.removeItem("mc_ws_token");
  }
  ["mc_imp_backup_agency", "mc_imp_backup_ws", "mc_imp_context", "mc_imp_target"].forEach((k) => localStorage.removeItem(k));
  window.location.href = "/console";
}

export function impTargetName() {
  return localStorage.getItem("mc_imp_target");
}
